<template>
  <div class="shop-section__main-container">
    <div class="shop-section__top-band shop-section__area"></div>
    <div class="shop-section__box text-center">

      <div class="shop-section__content-container shop-section__area">
        <div class="shop-section__title-wrapper">
            <div class="shop-section__title-container">
              <h2 class="shop-section__title--big team-numbers__presentation--title color--light">{{ title }}</h2>
              <h4 class="shop-section__title--normal team-numbers__presentation--subtitle color--light">{{ subtitle }}</h4>
              <br>
              <v-btn outline color="white" :to="{name: 'boutique'}">{{ linkName }}</v-btn>
            </div>
        </div>

        <div class="shop-section__hero-wrapper">
            <div class="shop-section__hero-grid">
              <img src="/static/assets/section/shop/v-3-1.png" alt="Boutique club Image 1" class="shop-section__hero-item l3 ll" />
              <img src="/static/assets/section/shop/v-4-1.png" alt="Boutique club Image 2" class="shop-section__hero-item l2 ll" />
              <img src="/static/assets/section/shop/v-5-2.png" alt="Boutique club Image 3" class="shop-section__hero-item l1" />
              <img src="/static/assets/section/shop/v-6-1.png" alt="Boutique club Image 4" class="shop-section__hero-item l2 lr" />
              <img src="/static/assets/section/shop/v-1-1.png" alt="Boutique club Image 5" class="shop-section__hero-item l3 lr" />
            </div>
        </div>
    </div>
  </div>


  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  props: {
    title: {
      type: String,
      default: "La boutique club"
    },
    subtitle: {
      type : String,
      default: "Découvrez les articles et accéssoires de la boutique BOP"
    },
    linkName: {
      type : String,
      default : "Voir la boutique"
    }
  }
}
</script>

<style lang="scss">
.shop-section__main-container {
  background-image: linear-gradient(45deg, darken(#05bdff, 30%) 50%, darken(#05bdff, 20%) 45%);
}
.shop-section__top-band {
  $shop-section-top-color: transparent;
  position: relative;
  border: 5px solid $shop-section-top-color;

  // margin-bottom: 4rem;

  &:before {
    content: " ";
    position: absolute;
    background-color: inherit;

    // draw triangle or // circle
    display : inline-block;

    $size: 4rem;
    border-color: $shop-section-top-color;
    border-style: solid;
    height: $size;
    width: $size * 2;
    border-bottom-left-radius: $size * 2;
    border-bottom-right-radius: $size * 2;

    // height : 0;
    // width : 0;
    // $size: 4rem;
    // border-top : $size solid #eee;
    // border-right : $sizesolid transparent;
    // border-left : $size solid transparent;

    // center
    bottom: -$size;
    left: 50%;
    transform: translateX(-50%);
  }
}

.shop-section__content-container {
  padding-bottom: 4rem;
}

.shop-section__title-wrapper {
  margin-top: 6.5rem;
  margin-bottom: 4rem;
}

.shop-section__hero-grid {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  max-height: 24.7rem;
}
.shop-section__hero-item {
  position: relative;
  display: inline-block;

  filter: drop-shadow(2px 2px 10px rgba(#fff, 1));

  &.l1 {
    position: relative;
    transform: translate(8%,-2%);
    z-index: 3;
  }

  &.l2, &.l3 {
    position: absolute;
    left: 50%;
  }

  &.l2 {
    z-index: 2;


    &.lr {
      transform: translate(70%, -10%);

    }
    &.ll {

      transform: translate(-100%, -10%);
    }
  }

  &.l3 {
    z-index: 1;
    &.lr {
      transform: translate(50%, -25%);
    }
    &.ll {
      transform: translate(-100%, -30%);
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/ShopSection.vue